import { RoomEvent, MatrixEvent, Room } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { matrixClient } from '../../client';

const fileLogger = new Log(false, 'im.client.room.handlers.receipt');
fileLogger.childrenPaused = true;
function onRoomReceipt(event: MatrixEvent, room: Room) {
    const logger = fileLogger.sub(false, 'onRoomReceipt')
    logger.pause = true;
    const receiptEventId = event.getId();
    const receiptContent = event.getContent();
    const receiptUserId = event.getSender();
    
    logger.log(`Receipt event in room ${room.name} (${room.roomId}):`);
    logger.log(`  User ${receiptUserId} marked event ${receiptEventId} as read`);
    
    // 这里可以添加处理回执的逻辑
    // 例如更新已读状态等
}

export const receiptHandler = {
    init() {
        matrixClient.clientOnEventDispatcher.addListener(RoomEvent.Receipt, onRoomReceipt);
    }
};
